import { data } from "@here/maps-api-for-javascript";
import images from "Assets/images";
import { routes } from "Library/Constants";

const tabs = [
  {
    id: 1,
    name: "booking_list",
    image: images.bookinglist,
    getUrl: routes.dashboardNav.bookingsList,
    url: "",
    isActive: false,
    isAvailable: true,
  },
  {
    id: 2,
    name: "calendar",
    image: images.calender,
    getUrl: routes.dashboardNav.calendar,
    url: "",
    isActive: false,
    isAvailable: true,
  },
  {
    id: 3,
    name: "vehicle_tracking",
    image: images.location,
    getUrl: routes.dashboardNav.vehicleTracking,
    url: "",
    isActive: false,
    isAvailable: true,
  },
  {
    id: 4,
    name: "user_management",
    image: images.users,
    getUrl: routes.dashboardNav.userManagement,
    url: "",
    isActive: false,
    isAvailable: true,
  },
  {
    id: 5,
    name: "project_management",
    image: images.siteManagement,
    url: "",
    isOpen: false,
    isActive: false,
    isAvailable: true,
    data: [
      {
        id: 1,
        name: "project_details",
        image: images.sidebarSiteDetails,
        getUrl: routes.dashboardNav.siteDetails,
        url: "",
        isActive: false,
        isAvailable: true,
      },
      {
        id: 2,
        name: "availability",
        image: images.sidebarAvailibity,
        getUrl: routes.dashboardNav.availability,
        url: "",
        isActive: false,
        isAvailable: true,
      },
      {
        id: 3,
        name: "project_setting",
        image: images.ProjectSettingLogo,
        getUrl: routes.dashboardNav.settings,
        url: "",
        isActive: false,
        isAvailable: true,
      },
      {
        id: 4,
        name: "environment_setting",
        image: images.siteManagement,
        url: "",
        isOpen: false,
        isActive: false,
        isAvailable: true,
        data: [
          {
            id: 1, // Make sure this ID is unique
            name: "vehicle_emission",
            image: images.emissions, // You'll need to add this icon to your images
            getUrl: routes.dashboardNav.vehicleEmission,
            url: "",
            isActive: false,
            isAvailable: true,
          },
          {
            id: 2, // Make sure this ID is unique
            name: "equipment_master",
            image: images.ProjectSettingLogo, // You'll need to add this icon to your images
            getUrl: routes.dashboardNav.equipment,
            url: "",
            isActive: false,
            isAvailable: true,
          },
          {
            id: 3, // Make sure this ID is unique
            isBottomTab: false,
            name: "global_settings",
            image: images.usage, // You'll need to add this icon to your images
            getUrl: routes.dashboardNav.commonSettings,
            url: "",
            isActive: false,
            isAvailable: true,
          },
          {
            id: 4, // Make sure this ID is unique
            name: "country_uom",
            image: images.sidebarSiteDetails, // You'll need to add this icon to your images
            getUrl: routes.dashboardNav.country,
            url: "",
            isActive: false,
            isAvailable: true,
          },
        ],
      },
    ],
  },

  {
    id: 6,
    name: "equipment_management",
    image: images.ProjectSettingLogo,
    url: "",
    isOpen: false,
    isActive: false,
    isAvailable: true,
    data: [
      {
        id: 1, // Make sure this ID is unique
        isBottomTab: false,
        name: "list_equipments",
        image: images.listings, // You'll need to add this icon to your images
        getUrl: routes.dashboardNav.listEquipments,
        url: "",
        isActive: false,
        isAvailable: true,
      },
      {
        id: 2, // Make sure this ID is unique
        isBottomTab: false,
        name: "equipment_usage",
        image: images.usage, // You'll need to add this icon to your images
        getUrl: routes.dashboardNav.monthlyUsage,
        url: "",
        isActive: false,
        isAvailable: true,
      },
    ],
  },
  {
    id: 7,
    name: "analytics",
    image: images.analytics,
    url: "",
    isOpen: false,
    isActive: false,
    isAvailable: true,
    data: [
      {
        id: 1,
        name: "summary_emissions_report",
        image: images.summary,
        getUrl: routes.dashboardNav.summaryEmissionsReport,
        url: "",
        isActive: false,
        isAvailable: true,
      },
      {
        id: 2,
        name: "vehicle_emission_reports",
        image: images.material,
        getUrl: routes.dashboardNav.materialEmissionReport,
        url: "",
        isActive: false,
        isAvailable: true,
      },
      {
        id: 3,
        name: "equipment_and_vehicle_emissions",
        image: images.cube,
        getUrl: routes.dashboardNav.offRoadEmissionsReport,
        url: "",
        isActive: false,
        isAvailable: true,
      },
      {
        id: 4,
        name: "environment_reports",
        image: images.cube,
        getUrl: routes.dashboardNav.environmentReport,
        url: "",
        isActive: false,
        isAvailable: true,
      },
    ],
  },
  {
    id: 8,
    isBottomTab: true,
    name: "Language",
    image: images.companySetting,
    url: "/contacts",
    languages: ["ENG UK", "ENG US"],
    data: [],
    isActive: false,
    isAvailable: true,
  },
];

export default tabs;

export const languageOption = [
  { value: "English US", label: "English US" },
  { value: "English UK", label: "English UK" },
];
